module.exports = __webpack_public_path__ + "static/media/instructivova5.61b27727.png";